<template>
  <div class="kongjian">
    <a-row style="height: 100%">
      <a-col :span="17" style="height: 100%">
        <ShowWpsFile
          ref="showWpsFile"
          :btnShow="false"
          :fileCode="code"
          :isReadOnly="'false'"
        />
      </a-col>
      <a-col :span="7">
        <a-row class="op-row">
          <a-col :span="8" class="title">处理类型：</a-col>
          <a-col :span="14">
            <a-select
              style="width: 100%"
              placeholder="请选择"
              @change="selectChange"
              v-model="auditStatus"
            >
              <a-select-option :value="8"> 审核完成 </a-select-option>
              <a-select-option :value="33">退改</a-select-option>
              <a-select-option :value="44">退稿</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row class="op-row">
          <a-col :span="8" class="title">处理意见：</a-col>
          <a-col :span="14">
            <a-textarea
              id="textarea"
              v-model="auditOpinion"
              :autoSize="{ minRows: 4, maxRows: 8 }"
            ></a-textarea>
          </a-col>
        </a-row>
        <div class="btn_div">
          <a-row>
            <a-button id="cancel" name="btn" class="btn" @click="cancel">
              关闭
            </a-button>
            <a-button id="save" name="btn" class="btn" @click="save">
              保存
            </a-button>
            <a-button
              id="submit"
              name="btn"
              class="btn"
              type="primary"
              @click="submit"
            >
              提交
            </a-button>
          </a-row>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import qs from "qs";
import ShowWpsFile from "../commomon/ShowWpsFile.vue";
export default {
  name: "manager",
  data() {
    return {
      code: "",
      auditStatus: null,
      auditOpinion: "",
    };
  },
  components: {
    ShowWpsFile,
  },
  created() {
    this.code = this.$route.query.code;
    this.axios
      .get("/outAuditOpinion/queryOutAuditOpinion", {
        params: {
          code: this.code,
          isSubmit: 0,
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then((res) => {
        if (res.data && res.data.data) {
          this.auditStatus = res.data.data.outAuditOpinion[0].result;
          this.auditOpinion = res.data.data.outAuditOpinion[0].note;
        }
      });
  },
  mounted() {},
  methods: {
    cancel() {
      this.$router.push("/waitAudit");
    },
    selectChange(status) {
      if (status == 44) {
        this.auditOpinion = "感谢来稿，未被采用。";
      } else if (status == 33) {
        this.auditOpinion = "请您修改稿件。";
      } else {
        this.auditOpinion = "";
      }
    },
    save() {
      this.audit(0);
    },
    submit() {
      this.audit(1);
    },
    audit(status) {
      this.$refs.showWpsFile.saveDoc(-1);
      this.axios
        .post("/outAuditOpinion/saveOutAuditOpinion", {
          code: this.code,
          auditer: sessionStorage.getItem("userCode"),
          note: this.auditOpinion,
          result: this.auditStatus,
          status: status,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.$router.push("/waitAudit");
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
    },
  },
};
</script>

<style scoped>
.kongjian {
  height: 100%;
  background-color: #fff;
}
.kongjian .btn_div {
  text-align: center;
  margin-top: 10px;
}
.kongjian .btn_div button {
  margin: 0 5px;
}
.kongjian .title {
  height: 36px;
  line-height: 36px;
  text-align: right;
}
.kongjian .op-row {
  margin-top: 10px;
}
</style>
